import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonButton,
  IonText,
  IonItem,
  IonList,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonSpinner,
} from '@ionic/react';
import { useAddStation } from '../../application/use-cases/hubs/useAddStation';

const AddStation: React.FC = () => {
  const { hubs, hubId, setHubId, loading, phase, secondsLeft, found, name, setName, error, saving, start, retry, save, goToClaimHub } =
    useAddStation();
  const hubLabel = (h: { id: string; siteName?: string | null }) => (h.siteName ? `${h.siteName} (${h.id})` : h.id);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/devices" />
          </IonButtons>
          <IonTitle>Agregar estación</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        {loading && (
          <div className="ion-text-center">
            <IonSpinner color="primary" />
          </div>
        )}

        {!loading && hubs.length === 0 && (
          <>
            <IonText>
              <p style={{ fontSize: 14, lineHeight: 1.6 }}>
                Las estaciones se conectan a través del hub del campo. Primero vinculá tu hub con el código de su etiqueta.
              </p>
            </IonText>
            <IonButton expand="block" onClick={goToClaimHub}>
              Vincular hub
            </IonButton>
          </>
        )}

        {!loading && hubs.length > 0 && phase === 'choose' && (
          <>
            <IonText color="medium">
              <p style={{ fontSize: 14, lineHeight: 1.6 }}>
                Prendé la estación nueva cerca del hub y tocá <strong>Buscar</strong>: el hub la encuentra sola y aparece en tu
                cuenta.
              </p>
            </IonText>
            {hubs.length > 1 && (
              <IonList inset>
                <IonItem>
                  <IonSelect
                    label="Hub del campo"
                    labelPlacement="stacked"
                    placeholder="Elegí el hub"
                    value={hubId}
                    onIonChange={(e) => setHubId(e.detail.value)}
                  >
                    {hubs.map((h) => (
                      <IonSelectOption key={h.id} value={h.id}>
                        {hubLabel(h)}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              </IonList>
            )}
            <IonButton expand="block" onClick={start} disabled={!hubId}>
              Buscar estación
            </IonButton>
          </>
        )}

        {phase === 'searching' && (
          <div className="ion-text-center" style={{ marginTop: 32 }}>
            <IonSpinner color="primary" />
            <p style={{ fontSize: 15, marginTop: 16 }}>Buscando la estación nueva…</p>
            <IonText color="medium">
              <p style={{ fontSize: 13 }}>
                Dejala prendida cerca del hub. Queda {Math.floor(secondsLeft / 60)}:{String(secondsLeft % 60).padStart(2, '0')}.
              </p>
            </IonText>
          </div>
        )}

        {phase === 'timeout' && (
          <>
            <IonText>
              <p style={{ fontSize: 14, lineHeight: 1.6 }}>
                No apareció ninguna estación nueva. Revisá que tenga batería y la antena puesta, acercala al hub y probá de
                nuevo. Si la estación ya estaba con otro hub, primero hay que hacerle olvidar ese hub (botón PRG 3 segundos).
              </p>
            </IonText>
            <IonButton expand="block" onClick={retry}>
              Probar de nuevo
            </IonButton>
          </>
        )}

        {phase === 'found' && found && (
          <>
            <IonText>
              <h2>¡La encontramos!</h2>
              <p style={{ fontSize: 14, lineHeight: 1.6 }}>Ponele un nombre para reconocerla. Después la podés ubicar en su lote.</p>
            </IonText>
            <IonList inset>
              <IonItem>
                <IonInput
                  label="Nombre"
                  labelPlacement="stacked"
                  placeholder="Ej. Estación Lote 4"
                  value={name}
                  onIonInput={(e) => setName(e.detail.value ?? '')}
                />
              </IonItem>
            </IonList>
            <IonButton expand="block" onClick={save} disabled={saving}>
              {saving ? 'Guardando...' : 'Listo'}
            </IonButton>
          </>
        )}

        {error && (
          <IonText color="danger">
            <p style={{ fontSize: 13 }}>{error}</p>
          </IonText>
        )}
      </IonContent>
    </IonPage>
  );
};

export default AddStation;
